import React, { createContext, useCallback, useContext, useState } from "react";
import { Alert, AlertColor, Snackbar } from "@mui/material";

interface SnackbarContextType {
    showSnackbar: (message: string, severity?: AlertColor) => void;
}

const SnackbarContext = createContext<SnackbarContextType>({
    showSnackbar: () => {},
});

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState<AlertColor>("error");

    const showSnackbar = useCallback(
        (message: string, severity: AlertColor = "error") => {
            setMessage(message);
            setSeverity(severity);
            setOpen(true);
        },
        []
    );

    return (
        <SnackbarContext.Provider value={{ showSnackbar }}>
            {children}
            <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={(_, reason) => {
                    if (reason === "clickaway") return;
                    setOpen(false);
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                sx={{ bottom: { xs: 80, sm: 24 } }}
            >
                <Alert
                    className="force-dynamic-translation"
                    onClose={() => setOpen(false)}
                    severity={severity}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};

export const useSnackbar = () => useContext(SnackbarContext);
